import { Breadcrumb, Product } from "../../types/types";

export const includedCategories = [
  {
    url: "/women/c50000298",
    name: "Women",
  },
  {
    url: "/men/c50000300",
    name: "Men",
  },
];

export const getBreadCrumbs = (product: Product) => {
  const breadCrumbs = product.browsePageHierarchy.map((browsePage) => {
    return {
      clickable: 1,
      value: browsePage.name?.toLowerCase(),
      url: "url" in browsePage ? browsePage.url : "",
    };
  });

  breadCrumbs.shift();
  return breadCrumbs;
};

type FeatureCategory = {
  name: string;
  url: string;
};

export const normalizeImageUrl = (url: string | null): string => {
  if (!url) {
    return "";
  }
  const trimmedUrl = url.trim();
  return trimmedUrl.indexOf("?") > -1 ? trimmedUrl : trimmedUrl + "?";
};

export const isFeatureEnabledForCategory = (
  breadCrumbs: Breadcrumb[] = [],
  featureCategories: FeatureCategory[] = [],
) => {
  const includedHash = getHash(featureCategories, "url");

  const hasIncluded = breadCrumbs.some((crumb) => includedHash[crumb.url]);

  return hasIncluded;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getHash<T extends { [key: string]: any }>(
  data: T[],
  key: string,
): Hash {
  return data.reduce((acc: Hash, item) => ({ ...acc, [item[key]]: true }), {});
}

interface Hash {
  [key: string]: boolean;
}
